"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputEase = exports.fontSize = exports.INPUT_SIZE_PROPS = void 0;
var _fonts = require("../../styles/fonts");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
/* Input ease has a slowe ease animation (material input) */
var inputEase = exports.inputEase = '0.2s ease';

/* Font sizes for all inputs/textareas */
var fontSize = exports.fontSize = {
  xxs: {
    fontSize: _fonts.fontSizes.s12
  },
  xs: {
    fontSize: _fonts.fontSizes.s14
  },
  sm: {
    fontSize: _fonts.fontSizes.s16
  },
  md: {
    fontSize: _fonts.fontSizes.s18
  },
  lg: {
    fontSize: _fonts.fontSizes.s20
  },
  xl: {
    fontSize: _fonts.fontSizes.s24
  },
  hg: {
    fontSize: _fonts.fontSizes.s36
  }
};

/* Sizes */
var INPUT_SIZE_PROPS = exports.INPUT_SIZE_PROPS = {
  system: {
    xs: {
      height: '24px',
      paddingLeft: _spacing["default"][4],
      fontSize: '14px',
      borderRadius: '2px'
    },
    sm: {
      height: '36px',
      paddingLeft: _spacing["default"][12],
      fontSize: '14px'
    },
    md: {
      height: '42px',
      paddingLeft: _spacing["default"][12],
      fontSize: '16px'
    },
    lg: {
      height: '48px',
      paddingLeft: _spacing["default"][16],
      fontSize: '18px'
    },
    xl: {
      height: '66px',
      paddingLeft: _spacing["default"][20],
      fontSize: '20px'
    }
  },
  builder: {
    sm: {
      height: '50px',
      paddingLeft: _spacing["default"][20],
      fontSize: '16px'
    },
    md: {
      height: '58px',
      paddingLeft: _spacing["default"][20],
      fontSize: '18px'
    },
    xl: {
      height: '64px',
      paddingLeft: _spacing["default"][20],
      fontSize: '24px'
    }
  }
};

/* Textfield: (input and textarea) sizes */
//# sourceMappingURL=variables.js.map